import { ActionTypes as action } from "./action-types";
import { initialState } from './state';
import _ from "lodash";

const mutations = {
    [action.GET_SURVEY_LIST](state, data) {
        state.pollSurveyQuestions = data
    },
    [action.GET_SURVEY_BY_ID](state, data) {
        if (!data.surveyParticipant) {
            data.surveyParticipant = []
        }
        state.surveyDetails = data
    },
    [action.GET_SURVEY_SUMMARY_BY_ID](state, data) {
        if (!data.surveyParticipant) {
            data.surveyParticipant = []
        }
        state.surveySummaryDetails = data
    },
    [action.GET_SURVEY_RESPONSE_RESULT](state, data) {
        state.surveyResponseResult = data
    },
    [action.RESET_SURVEY_OBJECT](state) {
        state.surveyDetails = _.cloneDeep(state.refSurveyDetails)
    },
    [action.ADD_SURVEY_QUESTION](state, question) {
        state.surveyDetails.questions.push(question)
    },
    [action.ADD_SURVEY_SECTION](state, section) {
        state.surveyDetails.sections.push(section)
    },
    [action.DELETE_SURVEY_QUESTION](state, id) {
        state.surveyDetails.questions = state.surveyDetails.questions.filter(
            (value) => value.id !== id
        );
    },
    [action.DELETE_JUST_SECTION](state, id) {
        const index = state.surveyDetails.sections.findIndex(
            (value) => value.sectionId === id
        );
        state.surveyDetails.sections = state.surveyDetails.sections.filter(
            (value) => value.sectionId !== id
        );
        if (state.surveyDetails.sections.length) {
            const arrIndex = state.surveyDetails.sections.length === 1 ? 0 : index - 1
            state.surveyDetails.questions = state.surveyDetails.questions.map(obj => {
                if (obj.sectionId === id) {
                    return { ...obj, sectionId: state.surveyDetails.sections[arrIndex].sectionId };
                }
                return obj;
            });

        } else {
            state.surveyDetails.questions = state.surveyDetails.questions.map(obj => { return { ...obj, sectionId: null }; });
        }
    },
    [action.DELETE_SECTION_AND_QUESTIONS](state, id) {
        state.surveyDetails.sections = state.surveyDetails.sections.filter(
            (value) => value.sectionId !== id
        );

        state.surveyDetails.questions = state.surveyDetails.questions.filter(
            (value) => value.sectionId !== id
        );
    },
    [action.RESET_STATE](state) {
        Object.assign(state, initialState);
    },
    setSurveySelector(state, surveyId) {
        state.selectorSurvey = surveyId
    },
    setDefaultDetails(state, data) {
        state.surveySummaryDetails = data
    },
    setDefaultCompairResult(state, data) {
        state.surveyCompairResult = data
    },
};

export default mutations;
